import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { pendingOnboarding } from "@/auth/onboarding";
import { BrandMark } from "@/components/brand-mark";
import { Card, CardContent } from "@/components/ui/card";

/**
 * Layout das telas de fora do painel (login, cadastro, recuperação).
 * Quem já tem sessão não tem o que fazer aqui — vai direto pro painel.
 */
export const Route = createFileRoute("/_public")({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) return;
    // Este redirecionamento dispara sozinho no instante em que o signup
    // autentica a sessão, ainda dentro da tela de cadastro. Sem olhar o
    // onboarding pendente ele mandaria a conta recém-criada direto pro
    // painel, pulando a escolha da persona.
    throw redirect({ to: pendingOnboarding() ? "/bem-vindo" : "/" });
  },
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-3xl">
        <Card className="overflow-hidden p-0">
          <CardContent className="grid p-0 md:grid-cols-2">
            {/* Piso de altura igual para todas as telas públicas: sem isto o
                card encolhe/estica ao navegar entre login, cadastro e
                recuperação, e a troca "pula" na tela — inclusive entre as duas
                etapas do cadastro. O valor cobre a mais alta delas (etapa 2 do
                cadastro: 650px de conteúdo + 64px de padding), com folga para
                as mensagens de erro e para quebras de linha em telas
                estreitas. */}
            <div className="flex flex-col justify-center p-6 md:min-h-[48rem] md:p-8">
              <Outlet />
            </div>
            <BrandPanel />
          </CardContent>
        </Card>
        <p className="mt-6 text-center text-xs text-muted-foreground">
          Agendo Certo — agendamento por WhatsApp
        </p>
      </div>
    </div>
  );
}

/**
 * Coluna visual em gradiente, sem depender de asset. Só aparece a partir de
 * `md` — no celular o formulário ocupa a tela inteira.
 *
 * O gradiente vai do NAVY para o azul, e não o contrário: os dois blocos de
 * texto ficam à esquerda, que num `to-br` é a ponta do `from`. Com o azul da
 * marca (#2CB1F5) ali, o texto branco caía pra ~2,2:1 de contraste — ele é
 * cor de preenchimento, não de fundo atrás de texto pequeno. Sobre o navy dá
 * ~12:1, e o azul segue aparecendo no canto oposto.
 */
function BrandPanel() {
  return (
    <div className="relative hidden bg-linear-to-br from-brand-strong via-brand-strong to-brand md:flex md:flex-col md:justify-between md:p-8">
      <div className="flex items-center gap-2.5 text-brand-foreground">
        <BrandMark className="size-7 [--brand-mark-ink:#fff]" />
        <span className="font-semibold tracking-tight">Agendo Certo</span>
      </div>
      <div className="space-y-2 text-brand-foreground">
        <p className="text-balance text-lg font-medium leading-snug">
          Sua agenda cheia, sem você ficar respondendo mensagem.
        </p>
        <p className="text-sm text-brand-foreground/80">
          Seus clientes marcam pelo WhatsApp. Você só confirma.
        </p>
      </div>
    </div>
  );
}
